import { createFileRoute } from "@tanstack/react-router";
import Termin from "@/pages/Termin";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/termin")({
  head: () =>
    seoHead({
      title: "Termin buchen: kostenloses Erstgespräch | Clicks DMP",
      description:
        "Buchen Sie ein kostenloses Erstgespräch für Ihr Foto-, Video- oder Social-Media-Projekt in Mannheim. Antwort innerhalb 1 Stunde.",
      path: "/termin",
    }),
  component: Termin,
});
